import React from 'react';
import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { cn } from '../../../lib/utils';

// Percentage change chip; nothing when there is no comparison.
// Ported from splitfin-manager src/components/dash/delta.tsx.
export const Delta: React.FC<{ value: number; previous?: number; lowerIsBetter?: boolean; className?: string }> = ({ value, previous, lowerIsBetter, className }) => {
  if (previous === undefined || previous === 0) return null;
  const delta = ((value - previous) / previous) * 100;
  const flat = Math.abs(delta) < 0.05;
  const up = delta > 0;
  const good = flat ? null : lowerIsBetter ? !up : up;
  const Icon = flat ? Minus : up ? ArrowUpRight : ArrowDownRight;
  return (
    <span
      title="vs previous period of equal length"
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[11px] font-semibold tabular-nums',
        good === null ? 'bg-[color:var(--oa-raised-2)] text-[color:var(--oa-muted)]' : good ? 'bg-[color:var(--oa-accent-soft)] text-[color:var(--oa-accent)]' : 'bg-[color:color-mix(in_oklab,var(--oa-bad)_12%,transparent)] text-[color:var(--oa-bad)]',
        className
      )}
    >
      <Icon className="h-3 w-3" aria-hidden />
      {flat ? '0%' : `${Math.abs(delta).toFixed(1)}%`}
    </span>
  );
};
